import { useState } from "react";
import { PiCaretDownLight } from "react-icons/pi";
import { PiCaretUp } from "react-icons/pi";
import { Button, DropdownToggle } from "reactstrap";

const IconedDropdownInput = ({
  Icon,
  className,
  value,
  setValue,
  placeholder,
  iconSize,
  options,
}) => {
  const [menuShown, setMenuShown] = useState(false);
  const toggleMenu = () => setMenuShown((prev) => !prev);
  return (
    <div
      className={`normal-input cursor-pointer position-relative d-flex align-items-center ${className}`}
      onClick={toggleMenu}
    >
      <div>
        <Icon size={iconSize} />
      </div>
      <div className="full-width">
        {value
          ? typeof value === "object"
            ? value?.title
            : value
          : placeholder}
      </div>
      <div>
        <PiCaretDownLight
          size={30}
          style={{
            transition: "0.2s linear all ",
            transform: `rotate(${menuShown ? "180deg" : "0"})`,
          }}
        />
      </div>
      {menuShown && (
        <div
          className="position-absolute drop-down-menu"
          style={{ top: "100%", right: 0, zIndex: 1000, width: "100%" }}
        >
          <div style={{ maxHeight: "250px", overflowY: "scroll" }}>
            {options?.map((item, key) => (
              <Button
                key={key}
                onClick={(e) => {
                  e?.stopPropagation();
                  setValue(item);
                  toggleMenu();
                }}
                className="drop-down-item"
              >
                {typeof item === "object" ? item?.title : item}
              </Button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default IconedDropdownInput;
